/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AorvExcelHochladenRequest,
  AorvImportEintrag,
  AorvImporteAusschnitt,
} from '../models/index';
import {
    AorvExcelHochladenRequestFromJSON,
    AorvExcelHochladenRequestToJSON,
    AorvImportEintragFromJSON,
    AorvImportEintragToJSON,
    AorvImporteAusschnittFromJSON,
    AorvImporteAusschnittToJSON,
} from '../models/index';

export interface AorvExcelHochladenOperationRequest {
    aorvExcelHochladenRequest: AorvExcelHochladenRequest;
}

export interface AorvImporteRequest {
    seite: number;
    anzahl: number;
    filter: string;
}

/**
 * AorvApi - interface
 * 
 * @export
 * @interface AorvApiInterface
 */
export interface AorvApiInterface {
    /**
     * 
     * @summary Excel Datei mit AORV-Aufträgen hochladen
     * @param {AorvExcelHochladenRequest} aorvExcelHochladenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AorvApiInterface
     */
    aorvExcelHochladenRaw(requestParameters: AorvExcelHochladenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AorvImportEintrag>>>;

    /**
     * Excel Datei mit AORV-Aufträgen hochladen
     */
    aorvExcelHochladen(requestParameters: AorvExcelHochladenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AorvImportEintrag>>;

    /**
     * 
     * @summary Gibt eine Liste von AORV-Importen für den angegebenen RSQL-Filter zurück.
     * @param {number} seite Seitennummer bei mehreren Seiten.
     * @param {number} anzahl Gibt die Anzahl der Elemente pro Seite an.
     * @param {string} filter Gibt den RSQL-Filter für die gewünschten Elemente an.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AorvApiInterface
     */
    aorvImporteRaw(requestParameters: AorvImporteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AorvImporteAusschnitt>>;

    /**
     * Gibt eine Liste von AORV-Importen für den angegebenen RSQL-Filter zurück.
     */
    aorvImporte(requestParameters: AorvImporteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AorvImporteAusschnitt>;

}

/**
 * 
 */
export class AorvApi extends runtime.BaseAPI implements AorvApiInterface {

    /**
     * Excel Datei mit AORV-Aufträgen hochladen
     */
    async aorvExcelHochladenRaw(requestParameters: AorvExcelHochladenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AorvImportEintrag>>> {
        if (requestParameters.aorvExcelHochladenRequest === null || requestParameters.aorvExcelHochladenRequest === undefined) {
            throw new runtime.RequiredError('aorvExcelHochladenRequest','Required parameter requestParameters.aorvExcelHochladenRequest was null or undefined when calling aorvExcelHochladen.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/allgemein/aorv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AorvExcelHochladenRequestToJSON(requestParameters.aorvExcelHochladenRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AorvImportEintragFromJSON));
    }

    /**
     * Excel Datei mit AORV-Aufträgen hochladen
     */
    async aorvExcelHochladen(requestParameters: AorvExcelHochladenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AorvImportEintrag>> {
        const response = await this.aorvExcelHochladenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gibt eine Liste von AORV-Importen für den angegebenen RSQL-Filter zurück.
     */
    async aorvImporteRaw(requestParameters: AorvImporteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AorvImporteAusschnitt>> {
        if (requestParameters.seite === null || requestParameters.seite === undefined) {
            throw new runtime.RequiredError('seite','Required parameter requestParameters.seite was null or undefined when calling aorvImporte.');
        }

        if (requestParameters.anzahl === null || requestParameters.anzahl === undefined) {
            throw new runtime.RequiredError('anzahl','Required parameter requestParameters.anzahl was null or undefined when calling aorvImporte.');
        }

        if (requestParameters.filter === null || requestParameters.filter === undefined) {
            throw new runtime.RequiredError('filter','Required parameter requestParameters.filter was null or undefined when calling aorvImporte.');
        }

        const queryParameters: any = {};

        if (requestParameters.seite !== undefined) {
            queryParameters['seite'] = requestParameters.seite;
        }

        if (requestParameters.anzahl !== undefined) {
            queryParameters['anzahl'] = requestParameters.anzahl;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/allgemein/aorv`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AorvImporteAusschnittFromJSON(jsonValue));
    }

    /**
     * Gibt eine Liste von AORV-Importen für den angegebenen RSQL-Filter zurück.
     */
    async aorvImporte(requestParameters: AorvImporteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AorvImporteAusschnitt> {
        const response = await this.aorvImporteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
